export default __webpack_public_path__ + "media/images/media-creator-e1a4931fee217e4baef4a06d7a92d766.jpg";